<header>
  <umss-skeleton [variant]="'Line'" [spacingX]="150"></umss-skeleton>
  <umss-skeleton [variant]="'Button'"></umss-skeleton>
</header>

<div class="skeleton-filters">
  <umss-skeleton [variant]="'Line'" [spacingX]="150"></umss-skeleton>
  <div>
    <umss-skeleton [variant]="'Button'"></umss-skeleton>
    <umss-skeleton [variant]="'Button'"></umss-skeleton>
    <umss-skeleton [variant]="'Button'"></umss-skeleton>
  </div>
</div>

<div class="skeleton-content">
  <umss-skeleton></umss-skeleton>
  <umss-skeleton></umss-skeleton>
  <umss-skeleton></umss-skeleton>
  <umss-skeleton></umss-skeleton>
</div>
